// extracted by mini-css-extract-plugin
export default {"Modal":"AlterRevisionConfirmModal_Modal__JpsOn","Content":"AlterRevisionConfirmModal_Content__S8gq+","Options":"AlterRevisionConfirmModal_Options__A9TfU"};